export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GalleryModule.vue?vue&type=template&id=5406714e&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/GalleryModule.vue?vue&type=template&id=5406714e&scoped=true
// module id = 344
// module chunks = 0